import React from 'react';
import { Route } from 'react-router-dom';

import { ADMIN_USERS_APP_PATHS } from '../constants/users-paths.constants';
import AdminCreateOrderView from '../../orders/views/AdminCreateOrder.view';
import AdminUsersListView from '../views/admin/AdminUsersList.view';
import AdminUserDetailsView from '../views/admin/AdminUserDetails.view';

export default function AdminUsersRoutes() {
  return (
    <React.Fragment>
      <Route exact path={ADMIN_USERS_APP_PATHS.USER_DETAILS(':userId')} component={AdminUserDetailsView} />
      <Route exact path={ADMIN_USERS_APP_PATHS.USER_CREATE_ORDER(':userId')} component={AdminCreateOrderView} />
      <Route exact path={ADMIN_USERS_APP_PATHS.USERS_LIST} component={AdminUsersListView} />
    </React.Fragment>
  );
}
